import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Helmet } from "react-helmet";

import styles from "./content-word.module.css";
import * as contentWordActions from "../../redux/actions/contentWord";
import { useImgLoaded } from "../../hooks/CustomHooks";
import { useQuery, useBackground } from "../../hooks/QueryHooks";
import { State } from "../../redux/store";
import { FINISH_STAGE } from "../../redux/reducers/stateIdentifiers";
import Placeholder from "../../components/Placeholder";
import Logo from "../../components/Logo";
import Board from "./Board";
import FinishBoard from "./FinishBoard";
import { pageTitle } from "../../util/Util";

interface Props {
  itemLeft: number;
}

const ContentWordGame = (props: Props) => {
  const { itemLeft } = props;
  const dispatch = useDispatch();
  useQuery();

  const { queryLoaded, grade, unit, gameConfigLoaded } = useSelector(
    (state: State) => state.shared
  );
  const { stage, words } = useSelector((state: State) => state.contentWord);
  const [imgLoaded, addImgLoaded] = useImgLoaded(1);
  const background = useBackground(grade, "content-word");

  useEffect(() => {
    if (queryLoaded && grade && unit) {
      dispatch(contentWordActions.importWords(grade, unit));
    }
  }, [queryLoaded]);

  if (!queryLoaded) return <Placeholder type="loading" />;
  if (!grade || !unit) return <Placeholder type="invalid" />;
  if (!gameConfigLoaded) return <Placeholder type="loading" />;
  if (!words.length) return <Placeholder type="invalid" />;

  return (
    <>
      <Helmet>
        <title>
          {pageTitle("Content Words Game", `Small Books Unit ${unit}`, grade)}
        </title>
      </Helmet>
      <div style={{ display: imgLoaded ? "block" : "none" }}>
        <img
          className={styles.bg}
          src={background}
          alt=""
          onLoad={addImgLoaded}
        />
        <Logo grade={grade} unit={unit} left={itemLeft} />
        {stage !== FINISH_STAGE && <Board />}
        {stage === FINISH_STAGE && <FinishBoard />}
      </div>
    </>
  );
};

export default ContentWordGame;
